__turbopack_context__.v({
  "root": "segmented-control-module__pflsbG__root",
});
